import React from 'react';
import heroImage from '../assets/images/hero.jpg';
import stripeImage from '../assets/images/stripe.png';
import breakspollLogo from '../assets/images/breakspoll-logo.svg';
import { heroSources, stripeSources } from '../assets/images/responsiveImages';
import '../assets/css/hero.css';

const HeroSection = () => {
  return (
    <section className="hero-section section-breakpoint">
      <div className="hero-image-wrapper">
        {/* Background image layer */}
        <picture>
          <source
            type="image/webp"
            srcSet={`${heroSources.small} 640w, ${heroSources.medium} 1280w, ${heroSources.desktop} 1600w, ${heroSources.large} 2000w`}
            sizes="100vw"
          />
          <img
            src={heroImage}
            alt=""
            className="hero-background"
            loading="eager"
            fetchpriority="high"
          />
        </picture>

        {/* Blue tint overlay */}
        <div className="blue-tint"></div>

        {/* Stripe pattern overlay */}
        <picture>
          <source
            type="image/webp"
            srcSet={`${stripeSources.small} 640w, ${stripeSources.medium} 1280w, ${stripeSources.desktop} 1600w, ${stripeSources.large} 1900w`}
            sizes="100vw"
          />
          <img src={stripeImage} alt="" className="stripe-overlay" decoding="async" />
        </picture>

        {/* Scanline effect */}
        <div className="scanline-overlay"></div>

        {/* Logo positioned at top-left */}
        <div className="logo-container">
          <img src={breakspollLogo} alt="Breakspoll Logo" className="breakspoll-logo" />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
